export const HOME = '/';
export const TEAMS = './teams';
export const RESULTS = './results';